import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  statsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(1),
  },
  chartSection: {
    display: 'flex',
    flexDirection: 'column',
  },

  chartTitle: {
    ...theme.mixins.appLabel,
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(1),
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
  chartContainer: {
    ...theme.mixins.appContainer,
    width: '100%',
    padding: 0,
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
}));
